import { IOnInit } from "angular";
import {
  ContractService,
  vsServiceName as ContractServiceName,
  ContractTypeService,
} from "../../../shared/ContractService";
import { File, Record } from "../../../../records/server/crud";
import {
  GridConfiguration,
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../../../records/views/recordGridView";
import { vsObjectName as contractInstanceName } from "../../../shared/configs/contractInstance";
import { RecordDataSource } from "../../../../records/grids";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import {
  SelectRecordModalService,
  vsServiceName as SelectRecordModalServiceName,
} from "../../../../records/services/selectRecordModal";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../../records/grids/settings/gridSettingsService";
import { StateService } from "@uirouter/angularjs";

interface ContractInstance extends Record {
  ContractInstanceId: number;
  Type: string;
  ContractNumber: string;
  ContractStartDate: Date;
  ContractEndDate: Date;
  ExecutedContract?: File;
  Files?: File[];
  Notes?: string;
}

interface RelationshipRole {
  Name: string;
  CanAddToNewRelationship?: boolean;
}

interface ContractRelationshipRole {
  Role: RelationshipRole;
  Contract: ContractInstance;
}

interface ContractRelationship {
  ContractRoles: ContractRelationshipRole[];
}

interface RelationshipType {
  Type: string;
  Roles: RelationshipRole[];
  Relationships: ContractRelationship;
}

interface ContractRelationships {
  Contract: ContractInstance;
  RelationshipTypes: RelationshipType[];
}

export class ContractRelationshipsController implements IOnInit {
  /* bindings */
  contract!: Record;
  contractRelationships!: ContractRelationships;
  /* bindings */

  static $inject = [
    ContractServiceName,
    RecordGridViewServiceName,
    ServerUtilityName,
    SelectRecordModalServiceName,
    GridSettingsServiceName,
    "$state",
  ];
  constructor(
    private readonly contractService: ContractService,
    private readonly recordGridViewService: RecordGridViewService,
    private readonly serverUtility: ServerUtility,
    private readonly selectRecordModalService: SelectRecordModalService,
    private readonly gridSettingsService: GridSettingsService,
    private readonly $state: StateService
  ) {}

  getContractType(type: string) {
    return this.contractService.getContractType(type);
  }

  selectOtherContract(type: RelationshipType, role: RelationshipRole) {
    if (!role.CanAddToNewRelationship) {
      return;
    }

    const otherRole = type.Roles.find((r) => r !== role)!;
    const gridConfiguration = this.getGridConfigurationForRole(type, otherRole);

    const modalInstance = this.selectRecordModalService.openModal({
      gridConfiguration,
      onItemSelected(item, mi) {
        mi.close(item);
      },
      title: "Contract",
    });

    modalInstance.result.then((r) =>
      this.createRelationship(type.Type, [
        {
          ContractInstanceId: <number>this.contract.ContractInstanceId,
          RelationshipRole: role.Name,
        },
        {
          ContractInstanceId: r.Id,
          RelationshipRole: otherRole.Name,
        },
      ]).then(() => {
        this.$state.reload();
      })
    );
  }

  getInfoSref(
    typeService: ContractTypeService,
    otherContractRole: ContractRelationshipRole
  ) {
    return typeService.infoSref(
      typeService.tabs?.find((t) => t.name === "Relationships"),
      {
        type: otherContractRole.Contract.Type,
        contractInstanceId: otherContractRole.Contract.Id,
      }
    );
  }

  deleteRelationship(contractRelationshipId: number) {
    this.serverUtility
      .sendApiRequest({
        method: "delete",
        url: `/api/contract/relationships/${contractRelationshipId}`,
      })
      .then(() => this.$state.reload());
  }

  private createRelationship(
    type: string,
    roles: { RelationshipRole: string; ContractInstanceId: number }[]
  ) {
    return this.serverUtility.sendApiRequest({
      url: `/api/contract/relationships/${type}`,
      method: "POST",
      data: {
        Roles: roles,
      },
    });
  }

 
  getGridConfigurationForRole(
    type: RelationshipType,
    role: RelationshipRole
  ): GridConfiguration {
    const gridConfiguration =
      this.recordGridViewService.getGridConfiguration(contractInstanceName)!;

    gridConfiguration.gridSettings = this.gridSettingsService.getGridSettings(
      Symbol("contract.relationships")
    );
    gridConfiguration.gridDataSource = new RecordDataSource(
      this.serverUtility,
      `/api/contract/relationships/types/${type.Type}/roles/${role.Name}/available`
    );

    gridConfiguration.columns = [...(gridConfiguration.columns ?? [])];

    return gridConfiguration;
  }

  $onInit(): void {}
}
